export class _ApplicationInfo {
    constructor() {
        this.isProcessedFirstLogin = false;
        this.saveLastLogin = true;
        this.BuildVersionData = null;
        this.login_language_selector = false;
        this.FrequencyLogsSending = 5;
        this.ExternalResourse = -1;
        this.LoginScreenType = 0;
        this.LoginLanguage = 'en';
        this.LoginToken = null;
        this.isExploreMode = false;
        this.exploreTheAppLink = null;
    }
}
export const ApplicationInfo = new _ApplicationInfo();
